import {Request, IRequestOptions} from 'Core/Common/Request';
import {P} from 'Core/Common/Promise';
import {GenericDeserialize} from 'libs/cerialize';

import {SubflowMonitorModel, SubflowMonitorRecordModel} from '../Models/Response/SubflowMonitorModel';

export class SubflowMonitorStore {
	static GetUnfinishedSubflowRecords(params: { EntityId: number; RecordId: number; LifeStatusId: number }): P.Promise<Array<SubflowMonitorModel>> {
		const deferredResult = P.defer<Array<SubflowMonitorModel>>();

		const requestParams: IRequestOptions = {
			proxy: {
				url: '/api/FollowUpApi/GetUnfinishedSubflowRecords',
				dataType: 'json',
				type: 'GET'
			},
			params: {
				entityId: params.EntityId,
				recordId: params.RecordId,
				lifeStatusId: params.LifeStatusId
			}
		};

		Request.Send(requestParams)
			.then((result: any[]) => deferredResult.resolve((result || []).map(item => GenericDeserialize(item, SubflowMonitorModel))))
			.fail(err => deferredResult.reject(err));

		return deferredResult.promise();
	}

	static GetUnfinishedSubflowRecordsByGate(params: {
		EntityId: number;
		RecordId: number;
		LifeStatusId: number;
		SubflowEntityId: number;
		SubflowTypeId: number;
	}): P.Promise<Array<SubflowMonitorRecordModel>> {
		const deferredResult = P.defer<Array<SubflowMonitorRecordModel>>();

		const requestParams: IRequestOptions = {
			proxy: {
				url: '/api/FollowUpApi/GetUnfinishedSubflowRecordsByGate',
				dataType: 'json',
				type: 'GET'
			},
			params: {
				entityId: params.EntityId,
				recordId: params.RecordId,
				lifeStatusId: params.LifeStatusId,
				subflowEntityId: params.SubflowEntityId,
				subflowTypeId: params.SubflowTypeId
			}
		};

		Request.Send(requestParams)
			.then((result: any[]) => deferredResult.resolve((result || []).map(item => GenericDeserialize(item, SubflowMonitorRecordModel))))
			.fail(err => deferredResult.reject(err));

		return deferredResult.promise();
	}
}
